import script from "./FirstLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./FirstLogin.vue?vue&type=script&setup=true&lang=js"

import "./FirstLogin.vue?vue&type=style&index=0&id=53aa141d&lang=scss"

const __exports__ = script;

export default __exports__